export default {
  code: "Code",
  name: "Name",
  invoice: "Invoice",
  taxes: "Taxes",
  tax: "Tax",
  taxCreated: "Tax created successfully",
  taxUpdated: "Tax updated successfully",
  taxesDeleted: "Taxes deleted successfully",
  createNewTax: "Create new tax",
  editTax: "Edit tax",
  taxCode: "Tax Code",
  taxRate: "Tax Rate",
  taxName: "Tax Name",
  taxDescription: "Tax Description",
  deleteTaxesTitle: "Delete taxes",
  deleteTaxesMessage:
    "Are you sure you want to delete the selected taxes? This action cannot be undone.",
  deleteSurchargeTitle: "Delete surcharge",
  deleteSurchargeMessage:
    "Are you sure you want to delete this surcharge? This action cannot be undone.",
};
